import { workspaceService } from '@/services/WorkspaceService';

const state = () => ({
  invitations: [],
  workspaces: [],
});

const mutations = {
  setWorkspaces(state: any, workspaces: any) {
    state.workspaces = workspaces;
  },
  setInvitations(state: any, invitations: any) {
    state.invitations = invitations;
  },
};

const actions = {
  getWorkspaces({ commit }: any) {
    return workspaceService
      .getWorkspaces()
      .then(data => {
        commit('setWorkspaces', data.workspaces);
        commit('setInvitations', data.invitations);
        return data;
      })
      .catch(() => {});
  },
};

const getters = {
  getWorkspaceById: (state: any) => (id: any) => {
    return state.workspaces.find((item: any) => item.id === id) || {};
  },
  getInvitationById: (state: any) => (id: any) => {
    return state.invitations.find((item: any) => item.id === id) || {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
